<template>
  <div id="subpage">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <b>会员管理</b>
        </el-breadcrumb-item>
        <el-breadcrumb-item>会员列表</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <div class="content">
      <div class="xcx-head">
        <div style="display: flex">
          <span>会员列表</span>
        </div>
        <!-- <span class="xcx-add left font14" @click="add()">添加会员</span> -->
      </div>
      <div class="search-box mt10">
        <el-form :inline="true">
          <el-form-item>
            <el-input placeholder="请输入关键词" v-model="search.keys"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="getIndex()" icon="el-icon-search" type="primary">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="getClearIndex()" icon="el-icon-delete" type="info">清空筛选</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="xcx-content">
        <!--列表-->
        <el-table border :data="tableData" stripe style="width: 100%" v-loading="loading">
          <el-table-column prop="id" label="UID" width="50"></el-table-column>
          <el-table-column prop="devid" label="DID" width="100"></el-table-column>
          <el-table-column label="头像" width="80">
            <template slot-scope="scope">
              <img :src="scope.row.avatar" height="25" width="25" />
            </template>
          </el-table-column>
          <el-table-column prop="nickname" label="昵称"></el-table-column>
          <el-table-column label="手机号" prop="mobile" width="120"></el-table-column>
          <el-table-column label="等级" width="100">
            <template slot-scope="scope">
              普通会员
            </template>
          </el-table-column>
          <el-table-column label="积分" width="80">0</el-table-column>
          <el-table-column prop="logintime" label="登录时间" width="160"></el-table-column>
          <el-table-column prop="loginip" label="登录IP" width="140"> </el-table-column>
          <el-table-column prop="created_at" label="注册时间" width="160"></el-table-column>
          <el-table-column label="状态" width="100">
            <template slot-scope="scope">
              <div v-if="scope.row.status == 1" class="text success">正常</div>
              <div v-else class="text danger">禁用</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120" fixed="right">
            <template slot-scope="scope">
              <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link">
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="beforeHandleCommand(scope.row.id, 'dev')">绑定设备</el-dropdown-item>
                  <el-dropdown-item :command="beforeHandleCommand(scope.row.id, 'edit')">修改</el-dropdown-item>
                  <el-dropdown-item :command="beforeHandleCommand(scope.row.id, 'del')">删除</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <!--分页-->
        <div class="paging">
          <el-pagination class="left" @current-change="handleCurrentChange" :current-page="page" background
            layout="total,prev, pager, next" :total="count"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: true,
      tableData: [],
      page: 0,
      count: 0,
      limit: 10,
      search: {
        keys: "",
      },
    };
  },
  //进入页面加载
  mounted: function () {
    var that = this;
    that.getList();
  },
  methods: {
    beforeHandleCommand(row, command) {
      return {
        row: row,
        command: command,
      };
    },
    handleCommand(command) {
      console.log(command);
      switch (command.command) {
        case "edit":
          this.dialogFormSwitch = true;
          break;
        case "dev":
          this.$router.push({
            path: "/dev/devusers",
            query: {
              uid: command.row,
            },
          });
          break;
        case "del":
          this.del_item(command.row);
          break;
      }
    },
    add() {
      //this.$router.push("/goods/add_goods");
    },
    edit(ids) {
      // this.$router.push({
      //   path: "/goods/add_goods",
      //   query: {
      //     id: ids,
      //   },
      // });
    },
    setIsTop(row) {
      var that = this;
      that.axios
        .post("/Activity/istop", { id: row.id, istop: row.istop })
        .then((res) => { });
    },
    setStatus(row) {
      var that = this;
      that.axios
        .post("/Activity/status", { id: row.id, istop: row.istop })
        .then((res) => { });
    },
    /**
     * 下一页
     */
    handleCurrentChange(currentPage) {
      var that = this;
      that.page = currentPage;
      that.getList();
    },
    del_item(ids) {
      let that = this;
      this.$confirm("此操作不可逆, 是否继续?", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          that.axios
            .post("/Users/destroy", {
              ids: ids,
            })
            .then((res) => {
              console.log(res);
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: res.msg,
                });
                that.getList();
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            });
        })
        .catch(() => { });
    },
    getIndex() {
      this.getList();
    },
    getClearIndex() {
      this.search.keys = "";
      this.getList();
    },
    /**
     * 获取列表
     */
    getList() {
      let that = this;
      let formData = {};
      var curr_page = sessionStorage.getItem("curr_page");
      that.page = curr_page ? curr_page - 0 : that.page;
      formData.page = that.page;
      formData.limit = that.limit;
      formData.keys = that.search.keys;
      that.axios.post("/users/index", formData).then((res) => {
        if (res) {
          that.tableData = res.data.data;
          that.count = res.data.total;
          that.page = curr_page ? curr_page : that.page;
          curr_page ? sessionStorage.removeItem("curr_page") : "";
          that.loading = false;
        }
      });
    },
  },
};
</script>
<style>
.search-box {
  padding: 0 20px;
}
</style>